import qs from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { ChartTypes, ProductTypes } from 'types/shared';
import { EntityTypes } from 'context/entityContext';

interface IGetChartPositionsUrl {
  chartFrequency?: string;
  chartIds?: number[];
  chartType?: ChartTypes;
  countryIds?: string | Array<number | string>;
  customerFilter?: string[];
  entityType: EntityTypes;
  entityIds: string[];
  productType?: ProductTypes;
  date?: number;
  limit?: number;
  isMainChartFilter?: boolean; // for Official charts
}

export default function getChartPositionsUrl(
  args: IGetChartPositionsUrl
): string {
  const {
    chartFrequency,
    chartIds,
    chartType,
    countryIds,
    customerFilter,
    entityType,
    entityIds,
    date,
    isMainChartFilter,
    limit,
  } = args;

  const type = entityTypeToApiType(entityType);
  const productType = args.productType || type;

  const params = qs.stringify({
    chartFrequency,
    chartIds,
    chartType,
    countryIds,
    customerFilter,
    productType,
    date,
    isMainChartFilter,
    ...(limit && { limit }),
  });

  return `/api/charts/positions/${type}/${entityIds}?${params}`;
}
